import { render, staticRenderFns } from "./deleteProfile.vue?vue&type=template&id=bd9877e4&scoped=true&"
import script from "./deleteProfile.vue?vue&type=script&lang=js&"
export * from "./deleteProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd9877e4",
  null
  
)

export default component.exports